import React, { useState, useEffect } from 'react';

const SupplierForm = ({ supplier, onSave, onCancel }) => {
  const [formData, setFormData] = useState({
    supplier_name: '',
    supplier_address: '',
    supplier_contact_info: ''
  });

  useEffect(() => {
    if (supplier) {
      setFormData({
        supplier_name: supplier.supplier_name || '',
        supplier_address: supplier.supplier_address || '',
        supplier_contact_info: supplier.supplier_contact_info || ''
      });
    }
  }, [supplier]);

  const handleChange = e => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = e => {
    e.preventDefault();
    onSave(formData);
  };

  return (
    <form onSubmit={handleSubmit}>
      <label>
        Name:
        <input name="supplier_name" value={formData.supplier_name} onChange={handleChange} required />
      </label>
      <label>
        Address:
        <input name="supplier_address" value={formData.supplier_address} onChange={handleChange} />
      </label>
      <label>
        Contact Info:
        <input name="supplier_contact_info" value={formData.supplier_contact_info} onChange={handleChange} />
      </label>
      <button type="submit">Save</button>
      <button type="button" onClick={onCancel}>Cancel</button>
    </form>
  );
};

export default SupplierForm;